import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Modal } from "pu-crossproduct-components/build/components/Organisms/Modal"
import { ModalHeader } from "pu-crossproduct-components/build/components/Molecules/DataDisplay/ModalHeader";
import { Button } from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import { ActionBarFooter } from "pu-crossproduct-components/build/components/Molecules/Inputs/ActionBar/ActionBarFooter";

interface IProps {
    open?: boolean;
}
interface IDispatch {
    onClose?: () => void;
}
export const InformatAccountDisabled: React.FC<IProps & IDispatch> = props => {
    const { t } = useTranslation();
    const header = <ModalHeader title={t("twoFactorInformatAccountDisabledTitle")} onClose={() => props.onClose && props.onClose()} />
    const footer = <ActionBarFooter
        rightSection={
            [<Button onClick={() => {
                props.onClose && props.onClose();
                window.open(`https://helpdesk.informat.be/hc/nl/articles/115001026364-Wachtwoord-vergeten-Account-geblokkeerd`);
            }}>{t("twoFactorInformatAccountDisbledGetHelp")}</Button>, <Button onClick={() => props.onClose && props.onClose()}>OK</Button>]} />

    return <Modal open={props.open} headerElement={header} footerElement={footer}>
        <Trans t={t} i18nKey='twoFactorInformatAccountDisabledContent' components={{ paragraph: <p /> }} />
    </Modal>
}